import { BaseEntity, Entity as DecribeEntity, RelationList } from '@lib/entity';

import { FileDocumentEntityList } from '@modules/shared/entities';

import type { FileDocumentEntity, FileDocumentEntityType } from '@modules/shared/entities';
import type { OlLecture, OlLectureType } from '@modules/types/graphql';

export type Entity =
    | (Partial<Omit<OlLecture, 'docs' | 'videos'>> & {
          docs?: (FileDocumentEntityType | null)[] | null;
          videos?: (FileDocumentEntityType | null)[] | null;
      })
    | null;

@DecribeEntity('LectureEntity')
class LectureEntity extends BaseEntity {
    id: string;
    name: string;
    subjectName: string;
    type: OlLectureType | null;
    text: string;
    createdAt: string;
    updatedAt: string;
    author: string;
    sort: number;
    status: string;
    textType?: string;
    userId?: string;

    @RelationList(() => FileDocumentEntityList)
    docs?: (FileDocumentEntity | null)[];

    @RelationList(() => FileDocumentEntityList)
    videos: FileDocumentEntity[];

    constructor(lecture: Entity) {
        super(lecture);

        this.id = lecture?.id ?? '';
        this.name = lecture?.name ?? '';
        this.subjectName = lecture?.subjectName ?? '';
        this.type = lecture?.type ?? null;
        this.text = lecture?.text ?? '';
        this.createdAt = lecture?.createdAt ?? '';
        this.updatedAt = lecture?.updatedAt ?? '';
        this.author = lecture?.author ?? '';
        this.sort = lecture?.sort ?? 0;
        this.status = lecture?.status ?? '';
        this.textType = lecture?.textType ?? '';
        this.userId = lecture?.userId ?? '';
    }

    exists() {
        const exists = this.id !== '';

        return exists;
    }

    hasText() {
        const hasText = this.text?.length > 11; // 11 is minimum length, when deleted all text from RichEditor (example: "<p><br></p>")

        return hasText;
    }
}

export { LectureEntity };
